import React from 'react'

const TestError = () => {
  React.useEffect(() => {
    throw new Error('From Effect')
  })

  return <div>Error effect</div>
}

export default TestError
